export const ThemeColorPropertyNames = {
    // Defaults from ISemanticColors and Semantic Slots
    BlockingBackground: '--ms-themeColorBlockingBackground',
    BlockingIcon: '--ms-themeColorBlockingIcon',
    BodyBackground: '--ms-themeColorBodyBackground',
    BodyBackgroundChecked: '--ms-themeColorBodyBackgroundChecked',
    BodyBackgroundHovered: '--ms-themeColorBodyBackgroundHovered',
    BodyDivider: '--ms-themeColorBodyDivider',
    BodyFrameBackground: '--ms-themeColorBodyFrameBackground',
    BodyFrameDivider: '--ms-themeColorBodyFrameDivider',
    BodyText: '--ms-themeColorBodyText',
    BodyTextChecked: '--ms-themeColorBodyTextChecked',
    BodyStandoutBackground: '--ms-themeColorBodyStandoutBackground',
    BodySubtext: '--ms-themeColorBodySubtext',
    DefaultStateBackground: '--ms-themeColorDefaultStateBackground',
    DisabledBodySubtext: '--ms-themeColorDisabledBodySubtext',
    DisabledBodyText: '--ms-themeColorDisabledBodyText',
    DisabledBorder: '--ms-themeColorDisabledBorder',
    ErrorBackground: '--ms-themeColorErrorBackground',
    ErrorBoxBackground: '--ms-themeColorErrorBoxBackground',
    ErrorIcon: '--ms-themeColorErrorIcon',
    ErrorBorder: '--ms-themeColorErrorBorder',
    ErrorBlock: '--ms-themeColorErrorBlock',
    DarkErrorBlock: '--ms-themeColorDarkErrorBlock',
    GrayErrorBackground: '--ms-themeColorGrayErrorBackground',
    DarkGrayErrorBackground: '--ms-themeColorDarkGrayErrorBackground',
    ErrorText: '--ms-themeColorErrorText',
    InfoText: '--ms-themeColorInfoText',
    RedErrorText: '--ms-themeColorRedErrorText',
    GrayIcon: '--ms-themeColorGrayIcon',
    FocusBorder: '--ms-themeColorFocusBorder',
    InfoBackground: '--ms-themeColorInfoBackground',
    InfoIcon: '--ms-themeColorInfoIcon',
    MessageLink: '--ms-themeColorMessageLink',
    MessageLinkHovered: '--ms-themeColorMessageLinkHovered',
    MessageText: '--ms-themeColorMessageText',
    SevereWarningBackground: '--ms-themeColorSevereWarningBackground',
    SevereWarningIcon: '--ms-themeColorSevereWarningIcon',
    SuccessBackground: '--ms-themeColorSuccessBackground',
    SuccessIcon: '--ms-themeColorSuccessIcon',
    VariantBorder: '--ms-themeColorVariantBorder',
    VariantBorderHovered: '--ms-themeColorVariantBorderHovered',
    WarningBackground: '--ms-themeColorWarningBackground',
    WarningHighlight: '--ms-themeColorWarningHighlight',
    WarningIcon: '--ms-themeColorWarningIcon',
    // Semantic Slots - Links
    ActionLink: '--ms-themeColorActionLink',
    ActionLinkHovered: '--ms-themeColorActionLinkHovered',
    Link: '--ms-themeColorLink',
    LinkHovered: '--ms-themeColorLinkHovered',
    // Semantic Slots - Buttons
    AccentButtonBackground: '--ms-themeColorAccentButtonBackground',
    AccentButtonText: '--ms-themeColorAccentButtonText',
    ButtonBackground: '--ms-themeColorButtonBackground',
    ButtonBackgroundChecked: '--ms-themeColorButtonBackgroundChecked',
    ButtonBackgroundHovered: '--ms-themeColorButtonBackgroundHovered',
    ButtonBackgroundCheckedHovered: '--ms-themeColorButtonBackgroundCheckedHovered',
    ButtonBackgroundPressed: '--ms-themeColorButtonBackgroundPressed',
    ButtonBackgroundDisabled: '--ms-themeColorButtonBackgroundDisabled',
    ButtonBorder: '--ms-themeColorButtonBorder',
    ButtonText: '--ms-themeColorButtonText',
    ButtonTextHovered: '--ms-themeColorButtonTextHovered',
    ButtonTextChecked: '--ms-themeColorButtonTextChecked',
    ButtonTextCheckedHovered: '--ms-themeColorButtonTextCheckedHovered',
    ButtonTextPressed: '--ms-themeColorButtonTextPressed',
    ButtonTextDisabled: '--ms-themeColorButtonTextDisabled',
    ButtonBorderDisabled: '--ms-themeColorButtonBorderDisabled',
    PrimaryButtonBackground: '--ms-themeColorPrimaryButtonBackground',
    PrimaryButtonBackgroundHovered: '--ms-themeColorPrimaryButtonBackgroundHovered',
    PrimaryButtonBackgroundPressed: '--ms-themeColorPrimaryButtonBackgroundPressed',
    PrimaryButtonBackgroundDisabled: '--ms-themeColorPrimaryButtonBackgroundDisabled',
    PrimaryButtonBorder: '--ms-themeColorPrimaryButtonBorder',
    PrimaryButtonText: '--ms-themeColorPrimaryButtonText',
    PrimaryButtonTextHovered: '--ms-themeColorPrimaryButtonTextHovered',
    PrimaryButtonTextPressed: '--ms-themeColorPrimaryButtonTextPressed',
    PrimaryButtonTextDisabled: '--ms-themeColorPrimaryButtonTextDisabled',
    // Semantic Slots - Inputs
    InputBorder: '--ms-themeColorInputBorder',
    InputBorderHovered: '--ms-themeColorInputBorderHovered',
    InputBackground: '--ms-themeColorInputBackground',
    InputBackgroundChecked: '--ms-themeColorInputBackgroundChecked',
    InputBackgroundCheckedHovered: '--ms-themeColorInputBackgroundCheckedHovered',
    InputPlaceholderBackgroundChecked: '--ms-themeColorInputPlaceholderBackgroundChecked',
    InputForegroundChecked: '--ms-themeColorInputForegroundChecked',
    InputIcon: '--ms-themeColorInputIcon',
    InputIconHovered: '--ms-themeColorInputIconHovered',
    InputIconDisabled: '--ms-themeColorInputIconDisabled',
    InputFocusBorderAlt: '--ms-themeColorInputFocusBorderAlt',
    SmallInputBorder: '--ms-themeColorSmallInputBorder',
    InputText: '--ms-themeColorInputText',
    InputTextHovered: '--ms-themeColorInputTextHovered',
    InputTextPressed: '--ms-themeColorInputTextPressed',
    InputPlaceholderText: '--ms-themeColorInputPlaceholderText',
    DisabledBackground: '--ms-themeColorDisabledBackground',
    DisabledText: '--ms-themeColorDisabledText',
    DisabledSubtext: '--ms-themeColorDisabledSubtext',
    // Semantic Slots - Lists
    ListBackground: '--ms-themeColorListBackground',
    ListText: '--ms-themeColorListText',
    ListTextColor: '--ms-themeColorListTextColor',
    ListItemBackgroundHovered: '--ms-themeColorListItemBackgroundHovered',
    ListItemBackgroundChecked: '--ms-themeColorListItemBackgroundChecked',
    ListItemBackgroundCheckedHovered: '--ms-themeColorListItemBackgroundCheckedHovered',
    ListHeaderBackgroundHovered: '--ms-themeColorListHeaderBackgroundHovered',
    ListHeaderBackgroundPressed: '--ms-themeColorListHeaderBackgroundPressed',
    // Semantic Slots - Menus
    MenuBackground: '--ms-themeColorMenuBackground',
    MenuBorder: '--ms-themeColorMenuBorder',
    MenuDivider: '--ms-themeColorMenuDivider',
    MenuIcon: '--ms-themeColorMenuIcon',
    MenuHeader: '--ms-themeColorMenuHeader',
    MenuItemBackgroundChecked: '--ms-themeColorMenuItemBackgroundChecked',
    MenuItemBackgroundHovered: '--ms-themeColorMenuItemBackgroundHovered',
    MenuItemBackgroundPressed: '--ms-themeColorMenuItemBackgroundPressed',
    MenuItemText: '--ms-themeColorMenuItemText',
    MenuItemTextHovered: '--ms-themeColorMenuItemTextHovered',
    MenuItemTextPressed: '--ms-themeColorMenuItemTextPressed',
    MenuItemTextChecked: '--ms-themeColorMenuItemTextChecked',
    // Used People card & People picker secondary text (Not in Fluent)
    MenuItemTextSecondary: '--ms-themeColorMenuItemTextSecondary',
    // Semantic Slots - Card
    CardShadow: '--ms-themeCardShadow',
    CardShadowHovered: '--ms-themeCardShadowHovered',
    CardStandoutBackground: '--ms-themeColorCardStandoutBackground',
    // Semantic Slots - Grabber
    GrabberBorderChecked: '--ms-grabberBorderChecked',
    GrabberBackgroundChecked: '--ms-grabberBackgroundChecked',
    GrabberColor: '--ms-grabberColor',
    GrabberColorChecked: '--ms-grabberColorChecked',
    // Semantic Slots - Checkbox
    CheckboxBackgroundUnchecked: '--ms-checkboxBackgroundUnchecked',
    CheckboxBackgroundChecked: '--ms-checkboxBackgroundChecked',
    CheckboxColorUnchecked: '--ms-checkboxColorUnchecked',
    CheckboxColorUncheckedHovered: '--ms-checkboxColorUncheckedHovered',
    CheckboxColorCheckedHovered: '--ms-checkboxColorCheckedHovered',
    CheckboxColorChecked: '--ms-checkboxColorChecked',
    CheckboxUnpopulated: '--ms-checkboxUnpopulated',
    // Semantic Tokens - Teams V2
    TeamsV2DefaultForeground2: '--ms-themeColorPaletteTeamsV2DefaultForeground2',
    TeamsV2DefaultForeground: '--ms-themeColorPaletteTeamsV2DefaultForeground',
    TeamsV2DefaultForegroundHover: '--ms-themeColorPaletteTeamsV2DefaultForegroundHover',
    TeamsV2DefaultForegroundPressed: '--ms-themeColorPaletteTeamsV2DefaultForegroundPressed',
    TeamsV2DefaultBackground: '--ms-themeColorPaletteTeamsV2DefaultBackground',
    TeamsV2DefaultBackgroundHover: '--ms-themeColorPaletteTeamsV2DefaultBackgroundHover',
    TeamsV2DefaultBackgroundPressed: '--ms-themeColorPaletteTeamsV2DefaultBackgroundPressed',
    TeamsV2DefaultBorder: '--ms-themeColorPaletteTeamsV2DefaultBorder',
    TeamsV2DefaultBorderHover: '--ms-themeColorPaletteTeamsV2DefaultBorderHover',
    TeamsV2DefaultBorderPressed: '--ms-themeColorPaletteTeamsV2DefaultBorderPressed',
    TeamsV2BrandForeground4: '--ms-themeColorPaletteTeamsV2BrandForeground4',
    TeamsV2BrandBackground: '--ms-themeColorPaletteTeamsV2BrandBackground',
    TeamsV2BrandBackgroundHover: '--ms-themeColorPaletteTeamsV2BrandBackgroundHover',
    TeamsV2BrandBackgroundPressed: '--ms-themeColorPaletteTeamsV2BrandBackgroundPressed',
    // Semantic Slots - Voting Button
    VotingButtonHoverShadow: '--ms-themeColorPaletteVotingButtonHoverShadow'
};
/** To be used with @FluidThemeNames ; refer to the documentation.  */ export const FluidThemePropertyNames = '--ms-themeColorThemeName';
// Following slots are not defined in fluentui/theme package
export const FluidThemeColorPropertyNames = {
    /** To be used with @FluidThemeNames ; refer to the documentation.  */ ThemeName: FluidThemePropertyNames,
    /** Value to be used with the -webkit-text-size-adjust css property within the components */ TextSizeAdjust: '--ms-themeTextSizeAdjust',
    Selection: '--ms-themeColorSelection',
    SelectionBackground: '--ms-themeColorSelectionBackground',
    SelectionBorder: '--ms-themeColorSelectionBorder',
    // Tear Off Page - Drag and Drop
    DragDropTearOffPageBorder: '--ms-themeColorPaletteDragDropTearOffPageBorder',
    DragDropTearOffPageBackground: '--ms-themeColorPaletteDragDropTearOffPageBackground',
    // Semantic Slots - Block Component Placeholder
    // TODO:TEAROFF: Remove these theme slots once multiview support is fully finished
    BlockComponentPlaceholderBackground: '--ms-themeColorPaletteBlockComponentPlaceholderBackground',
    // Semantic Slots - AtMentions
    AtMentionBackgroundMe: '--ms-themeColorPaletteAtMentionBackGroundMe',
    AtMentionTextMe: '--ms-themeColorPaletteAtMentionTextMe',
    AtMentionBackgroundOther: '--ms-themeColorPaletteAtMentionBackgroundOther',
    AtMentionTextOther: '--ms-themeColorPaletteAtMentionTextOther',
    AtMentionBackgroundHighlight: '--ms-themeColorPaletteAtMentionBackgroundHighlight',
    AtMentionHighlightBorder: '--ms-themeColorPaletteAtMentionHighlightBorder',
    // Semantic Slots - AtMentions - Unresolved
    AtMentionUnresolvedBackground: '--ms-themeColorPaletteAtMentionUnresolvedBackground',
    AtMentionUnresolvedBackgroundHovered: '--ms-themeColorPaletteAtMentionUnresolvedBackgroudHovered',
    AtMentionUnresolvedBackgroundPressed: '--ms-themeColorPaletteAtMentionsUnresolvedBackgroundPressed',
    AtMentionUnresolvedBackgroundSelected: '--ms-themeColorPaletteAtMentionUnresolvedBackgroudSelected',
    AtMentionUnresolvedIcon: '--ms-themeColorPaletteAtMentionUnresolvedIcon',
    AtMentionUnresolvedIconHovered: '--ms-themeColorPaletteAtMentionUnresolvedIconHovered',
    AtMentionUnresolvedIconPressed: '--ms-themeColorPaletteAtMentionUnresolvedIconPressed',
    AtMentionUnresolvedIconSelected: '--ms-themeColorPaletteAtMentionUnresolvedIconSelected',
    AtMentionUnresolvedIconInner: '--ms-themeColorPaletteAtMentionUnresolvedIconInner',
    AtMentionUnresolvedIconInnerHovered: '--ms-themeColorPaletteAtMentionUnresolvedIconInnerHovered',
    AtMentionUnresolvedIconInnerPressed: '--ms-themeColorPaletteAtMentionUnresolvedIconInnerPressed',
    AtMentionUnresolvedIconInnerSelected: '--ms-themeColorPaletteAtMentionUnresolvedIconInnerSelected',
    AtMentionUnresolvedOutline: '--ms-themeColorPaletteAtMentionUnresolvedOutline',
    AtMentionUnresolvedOutlineHovered: '--ms-themeColorPaletteAtMentionUnresolvedOutlineHovered',
    AtMentionUnresolvedOutlinePressed: '--ms-themeColorPaletteAtMentionUnresolvedOutlinePressed',
    AtMentionUnresolvedOutlineSelected: '--ms-themeColorPaletteAtMentionUnresolvedOutlineSelected',
    // Semantic Slots - IconButton
    IconButton: '--ms-themeColorIconButton',
    IconButtonHovered: '--ms-themeColorIconButtonHovered',
    IconButtonPressed: '--ms-themeColorIconButtonPressed',
    IconButtonChecked: '--ms-themeColorIconButtonChecked',
    IconButtonBackground: '--ms-themeColorIconButtonBackground',
    IconButtonBackgroundHovered: '--ms-themeColorIconButtonBackgroundHovered',
    IconButtonBackgroundPressed: '--ms-themeColorIconButtonBackgroundPressed',
    IconButtonBackgroundChecked: '--ms-themeColorIconButtonBackgroundChecked',
    // Semantic Slots - Overflow Button
    OverflowText: '--ms-themeColorOverflowText',
    OverflowTextHovered: '--ms-themeColorOverflowTextHovered',
    OverflowTextPressed: '--ms-themeColorOverflowTextPressed',
    OverflowTextChecked: '--ms-themeColorOverflowTextChecked',
    OverflowBackground: '--ms-themeColorOverflowBackground',
    OverflowBackgroundHovered: '--ms-themeColorOverflowBackgroundHovered',
    OverflowBackgroundPressed: '--ms-themeColorOverflowBackgroundPressed',
    OverflowBackgroundChecked: '--ms-themeColorOverflowBackgroundChecked',
    // Semantic Slots - Menus
    MenuBorder: '--ms-themeColorMenuBorder',
    // Semantic Slots - PermissionsPanel Tooltip
    TooltipText: '--ms-themeColorTooltipText',
    TooltipBackground: '--ms-themeColorTooltipBackground',
    // Semantic Slots - Calendar (used in Dias for now)
    CalendarCellText: '--ms-themeColorCalendarCellText',
    CalendarCellTextHovered: '--ms-themeColorCalendarCellTextHovered',
    CalendarCellTextChecked: '--ms-themeColorCalendarCellTextChecked',
    CalendarCellTextToday: '--ms-themeColorCalendarCellTextToday',
    CalendarHeaderText: '--ms-themeColorCalendarHeaderText',
    CalendarBackground: '--ms-themeColorCalendarBackground',
    CalendarCellBackground: '--ms-themeColorCalendarCellBackground',
    CalendarCellBackgroundHovered: '--ms-themeColorCalendarCellBackgroundHovered',
    CalendarCellBackgroundChecked: '--ms-themeColorCalendarCellBackgroundSelected',
    CalendarCellBackgroundToday: '--ms-themeColorCalendarCellBackgroundToday',
    // Semantic Slots - inline text in Dias
    DatePickerTextToday: '--ms-themeColorDatePickerTextToday',
    DatePickerTextTomorrow: '--ms-themeColorDatePickerTextTomorrow',
    DatePickerTextYesterday: '--ms-themeColorDatePickerTextYesterday',
    DatePickerTextOther: '--ms-themeColorDatePickerTextOther',
    DatePickerBackgroundToday: '--ms-themeColorDatePickerBackgroundToday',
    DatePickerBackgroundTomorrow: '--ms-themeColorDatePickerBackgroundTomorrow',
    DatePickerBackgroundYesterday: '--ms-themeColorDatePickerBackgroundYesterday',
    DatePickerBackground: '--ms-themeColorDatePickerBackground',
    DatePickerGrayedText: '--ms-themeColorDatePickerGrayedText',
    DatePickerGrayedBackground: '--ms-themeColorDatePickerGrayedBackground',
    // Semantic Slots - inline text in Dias when used in inlineTask
    TaskDueDateTextToday: '--ms-themeColorDatePickerTextToday',
    TaskDueDateTextTomorrow: '--ms-themeColorDatePickerTextTomorrow',
    TaskDueDateTextYesterday: '--ms-themeColorDatePickerTextYesterday',
    TaskDueDateTextOther: '--ms-themeColorDatePickerTextOther',
    // Semantic Slots - Persona
    PersonaBorder: '--ms-themeColorPersonaBorder',
    PersonaText: '--ms-themeColorPersonaText',
    // Semantic colors - Theme Colors with Alpha
    BodyBackgroundWithAlpha: '--ms-themeColorBodyBackgroundWithAlpha',
    // Semantic Slots - Error Callout
    ErrorCalloutText: '--ms-themeColorErrorCalloutText',
    ErrorCalloutBackground: '--ms-themeColorErrorCalloutBackground',
    // Semantic Slots - Snackbar
    ErrorSnackbarText: '--ms-themeColorErrorSnackbarText',
    ErrorSnackbarBackground: '--ms-themeColorErrorSnackbarBackground',
    WarningSnackbarText: '--ms-themeColorWarningSnackbarText',
    WarningSnackbarBackground: '--ms-themeColorWarningSnackbarBackground',
    // Semantic Slots - Attribution
    TextSelectionBackgroundHovered: '--ms-themeColorPaletteTextSelectionBackgroundHovered',
    TextSelectionBackgroundPressed: '--ms-themeColorPaletteTextSelectionBackgroundPressed',
    TextSelectionEndCap: '--ms-themeColorPaletteTextSelectionEndCap',
    TextSelectionHorizontalCap: '--ms-themeColorPaletteTextSelectionHorizontalCap',
    FloatieText: '--ms-themeColorPaletteFloatieText',
    FloatieTextHovered: '--ms-themeColorPaletteFloatieTextHovered',
    FloatieTextPressed: '--ms-themeColorPaletteFloatieTextPressed',
    FloatieBackground: '--ms-themeColorPaletteFloatieBackground',
    FloatieBackgroundHovered: '--ms-themeColorPaletteFloatieBackgroundHovered',
    FloatieBackgroundPressed: '--ms-themeColorPaletteFloatieBackgroundPressed',
    FloatieBorder: '--ms-themeColorPaletteFloatieBorder',
    FloatieBorderHovered: '--ms-themeColorPaletteFloatieBorderHovered',
    FloatieBorderPressed: '--ms-themeColorPaletteFloatieBorderPressed',
    // Font color
    FontColorRed: '--ms-themeColorPaletteFontColorRed',
    FontColorOrange: '--ms-themeColorPaletteFontColorOrange',
    FontColorYellow: '--ms-themeColorPaletteFontColorYellow',
    FontColorGreen: '--ms-themeColorPaletteFontColorGreen',
    FontColorBlueGreen: '--ms-themeColorPaletteFontColorBlueGreen',
    FontColorBlue: '--ms-themeColorPaletteFontColorBlue',
    FontColorPurple: '--ms-themeColorPaletteFontColorPurple',
    // Background color
    BackgroundColorRed: '--ms-themeColorPaletteBackgroundColorRed',
    BackgroundColorOrange: '--ms-themeColorPaletteBackgroundColorOrange',
    BackgroundColorYellow: '--ms-themeColorPaletteBackgroundColorYellow',
    BackgroundColorGreen: '--ms-themeColorPaletteBackgroundColorGreen',
    BackgroundColorBlueGreen: '--ms-themeColorPaletteBackgroundColorBlueGreen',
    BackgroundColorBlue: '--ms-themeColorPaletteBackgroundColorBlue',
    BackgroundColorPurple: '--ms-themeColorPaletteBackgroundColorPurple',
    // Acrylic menu background color
    BackgroundAcrylicColorized: '--colorBackgroundAcrylicColorized',
    BackgroundAcrylicColorizedFallback: '--colorBackgroundAcrylicColorizedFallback',
    BackgroundAcrylicNeutral: '--colorBackgroundAcrylicNeutral',
    BackgroundAcrylicNeutralFallback: '--colorBackgroundAcrylicNeutralFallback',
    // Semantic Slots - ComponentGlowBorder
    ComponentGlowBorder1: '--ms-themeColorPaletteComponentGlowBorder1',
    ComponentGlowBorder2: '--ms-themeColorPaletteComponentGlowBorder2',
    ComponentGlowBorder3: '--ms-themeColorPaletteComponentGlowBorder3',
    ComponentGlowBorder4: '--ms-themeColorPaletteComponentGlowBorder4',
    ComponentGlowBorder5: '--ms-themeColorPaletteComponentGlowBorder5',
    // Semantic Slots - In canvas presence, e.g. scriptor presence
    /** Used for the text in component presence, like user name, user initials. */ InCanvasPresenceText: '--ms-themeColorInCanvasPresenceText'
};
/**
 * Theme names that the hosts can set through theming properties for the
 * FluidThemeColorPropertyNames.ThemeName token in order to communicate
 * an idea of the sets of token values that are being fed into the system.
 * This is used by some components that have a fixed palette of colors
 * that are not configurable directly by the host in order to offer a
 * successful experience.
 * This parameters are optional and are not required to be passed-in by
 * the host unless the host wants to get the best experience with the components
 * that would use this. If the value is not assigned, the components that
 * work with this should assume their default behavior/palette.
 *
 * List of components that use these values:
 * - Codelo
 * - Labels
 * - Editor features
 */ export const FluidThemeNames = {
    Default: 'default',
    Dark: 'dark',
    HighContrast: 'high-contrast'
};
export const FluidThemeLayoutCssPropertyName = {
    BorderRadiusErrorCallout: '--ms-themeBorderRadiusErrorCallout',
    BorderRadiusSnackbar: '--ms-themeBorderRadiusSnackbar',
    BorderRadiusCalloutSurface: '--ms-themeBorderRadiusCalloutSurface',
    BorderRadiusCalloutButton: '--ms-themeBorderRadiusCalloutButton',
    BorderRadiusInput: '--ms-themeBorderRadiusInput',
    BorderRadiusContextualMenuIcon: '--ms-themeBorderRadiusContextualMenuIcon',
    BoxShadowCalloutSurface: '--ms-theme BoxShadowCalloutSurface',
    PaddingCalloutSurface: '--ms-themePaddingCalloutSurface'
};
export const ThemeLayoutCssPropertyName = {
    MarginTopBody: '--ms-themeMarginTopBody',
    MarginTopHeading1: '--ms-themeMarginTopHeading1',
    MarginTopHeading2: '--ms-themeMarginTopHeading2',
    MarginTopHeading3: '--ms-themeMarginTopHeading3',
    LineHeightBody: '--ms-themeLineHeightBody',
    LineHeightHeading1: '--ms-themeLineHeightHeading1',
    LineHeightHeading2: '--ms-themeLineHeightHeading2',
    LineHeightHeading3: '--ms-themeLineHeightHeading3',
    OutlineBody: '--ms-themeOutlineBody',
    OutlineHeading1: '--ms-themeOutlineHeading1',
    OutlineHeading2: '--ms-themeOutlineHeading2',
    OutlineHeading3: '--ms-themeOutlineHeading3',
    TextDecorationComplement: '--ms-themeTextDecorationComplement'
};
export const ThemeFontsCssPropertyName = {
    FontFamilyBody: '--ms-themeFontFamilyBody',
    FontFamilyHeading1: '--ms-themeFontFamilyHeading1',
    FontFamilyHeading2: '--ms-themeFontFamilyHeading2',
    FontFamilyHeading3: '--ms-themeFontFamilyHeading3',
    FontFamilyMenu: '--ms-themeFontFamilyMenu',
    FontFamilyButton: '--ms-themeFontFamilyButton',
    FontSizeBody: '--ms-themeFontSizeBody',
    FontSizeHeading1: '--ms-themeFontSizeHeading1',
    FontSizeHeading2: '--ms-themeFontSizeHeading2',
    FontSizeHeading3: '--ms-themeFontSizeHeading3',
    FontSizeHeading4: '--ms-themeFontSizeHeading4',
    FontSizeMenu: '--ms-themeFontSizeMenu',
    FontSizeButton: '--ms-themeFontSizeButton',
    FontWeightBody: '--ms-themeFontWeightBody',
    FontWeightHeading1: '--ms-themeFontWeightHeading1',
    FontWeightHeading2: '--ms-themeFontWeightHeading2',
    FontWeightHeading3: '--ms-themeFontWeightHeading3',
    FontWeightMenu: '--ms-themeFontWeightMenu',
    FontWeightButton: '--ms-themeFontWeightButton'
};
export const ThemeColorPaletteSlots = {
    PinkRed10: '--ms-themeColorPaletteSharedPinkRed10',
    Red20: '--ms-themeColorPaletteSharedRed20',
    Red10: '--ms-themeColorPaletteSharedRed10',
    RedOrange10: '--ms-themeColorPaletteSharedRedOrange10',
    Orange30: '--ms-themeColorPaletteSharedOrange30',
    Orange20: '--ms-themeColorPaletteSharedOrange20',
    Orange10: '--ms-themeColorPaletteSharedOrange10',
    Yellow20: '--ms-themeColorPaletteSharedYellow20',
    Yellow10: '--ms-themeColorPaletteSharedYellow10',
    OrangeYellow20: '--ms-themeColorPaletteSharedOrangeYellow20',
    OrangeYellow10: '--ms-themeColorPaletteSharedOrangeYellow10',
    YellowGreen10: '--ms-themeColorPaletteSharedYellowGreen10',
    Green20: '--ms-themeColorPaletteSharedGreen20',
    Green10: '--ms-themeColorPaletteSharedGreen10',
    GreenCyan10: '--ms-themeColorPaletteSharedGreenCyan10',
    Cyan30: '--ms-themeColorPaletteSharedCyan30',
    Cyan20: '--ms-themeColorPaletteSharedCyan20',
    Cyan10: '--ms-themeColorPaletteSharedCyan10',
    CyanBlue20: '--ms-themeColorPaletteSharedCyanBlue20',
    CyanBlue10: '--ms-themeColorPaletteSharedCyanBlue10',
    Blue10: '--ms-themeColorPaletteSharedBlue10',
    BlueMagenta30: '--ms-themeColorPaletteSharedBlueMagenta30',
    BlueMagenta20: '--ms-themeColorPaletteSharedBlueMagenta20',
    BlueMagenta10: '--ms-themeColorPaletteSharedBlueMagenta10',
    Magenta20: '--ms-themeColorPaletteSharedMagenta20',
    Magenta10: '--ms-themeColorPaletteSharedMagenta10',
    MagentaPink20: '--ms-themeColorPaletteSharedMagentaPink20',
    MagentaPink10: '--ms-themeColorPaletteSharedMagentaPink10',
    Gray430: '--ms-themeColorPaletteSharedGray430',
    Gray180: '--ms-themeColorPaletteSharedGray180',
    Gray130: '--ms-themeColorPaletteSharedGray130',
    Gray100: '--ms-themeColorPaletteSharedGray100',
    Gray50: '--ms-themeColorPaletteSharedGray50',
    Gray40: '--ms-themeColorPaletteSharedGray40',
    Gray30: '--ms-themeColorPaletteSharedGray30',
    Gray20: '--ms-themeColorPaletteSharedGray20',
    Gray10: '--ms-themeColorPaletteSharedGray10',
    Gray4: '--ms-themeColorPaletteSharedGray4',
    Gray6: '--ms-themeColorPaletteSharedGray6',
    Gray5: '--ms-themeColorPaletteSharedGray5',
    Gray1: '--ms-themeColorPaletteSharedGray1',
    Away: '--ms-themeColorPalettePresenceAway',
    DoNotDisturb: '--ms-themeColorPalettePresenceDoNotDisturb',
    Online: '--ms-themeColorPalettePresenceOnline',
    Invisible: '--ms-themeColorPalettePresenceInvisible',
    OutOfOffice: '--ms-themeColorPalettePresenceOutOfOffice',
    Warning: '--ms-themeColorPaletteMessagingWarning',
    WarningIcon: '--ms-themeColorPaletteMessagingWarningIcon',
    SevereWarning: '--ms-themeColorPaletteMessagingSevereWarning',
    SevereWarningIcon: '--ms-themeColorPaletteMessagingServereWarningIcon',
    ErrorBlock: '--ms-themeColorPaletteMessagingErrorBlock',
    ErrorBlockIcon: '--ms-themeColorPaletteMessagingErrorBlockIcon',
    ErrorBackground: '--ms-themeColorPaletteMessagingErrorBackground',
    ErrorBoxBackground: '--ms-themeColorPaletteMessagingErrorBoxBackground',
    ErrorText: '--ms-themeColorPaletteMessagingErrorText',
    InfoText: '--ms-themeColorPaletteMessagingInfoText',
    DarkErrorBlock: '--ms-themeColorPaletteMessagingDarkErrorBlock',
    GrayErrorBackground: '--ms-themeColorPaletteMessagingGrayErrorBackground',
    DarkGrayErrorBackground: '--ms-themeColorPaletteMessagingDarkGrayErrorBackground',
    GrayErrorText: '--ms-themeColorPaletteMessagingGrayErrorText',
    RedErrorText: '--ms-themeColorPaletteMessagingRedErrorText',
    GrayIcon: '--ms-themeColorPaletteMessagingGrayIcon',
    ButtonText: '--ms-themeColorPaletteMessagingButtonText',
    Success: '--ms-themeColorPaletteMessagingSuccess',
    SuccessIcon: '--ms-themeColorPaletteMessagingSuccessIcon',
    themeDarker: '--ms-themeColorPaletteThemeDarker',
    themeDark: '--ms-themeColorPaletteThemeDark',
    themeDarkAlt: '--ms-themeColorPaletteThemeDarkAlt',
    themePrimary: '--ms-themeColorPaletteThemePrimary',
    themeSecondary: '--ms-themeColorPaletteThemeSecondary',
    themeTertiary: '--ms-themeColorPaletteThemeTertiary',
    themeLight: '--ms-themeColorPaletteThemeLight',
    themeLighter: '--ms-themeColorPaletteThemeLighter',
    themeLighterAlt: '--ms-themeColorPaletteThemeLightAlt',
    black: '--ms-themeColorPaletteBlack',
    neutralDark: '--ms-themeColorPaletteNeutralDark',
    neutralPrimary: '--ms-themeColorPaletteNeutralPrimary',
    neutralPrimaryAlt: '--ms-themeColorPaletteNeutralPrimaryAlt',
    neutralSecondary: '--ms-themeColorPaletteNeutralSecondary',
    neutralSecondaryAlt: '--ms-themeColorPaletteNeutralSecondaryAlt',
    neutralTertiary: '--ms-themeColorPaletteNeutralTertiary',
    neutralTertiaryAlt: '--ms-themeColorPaletteNeutralTertiaryAlt',
    neutralQuaternary: '--ms-themeColorPaletteNeutralQuaternary',
    neutralQuaternaryAlt: '--ms-themeColorPaletteNeutralQuaternaryAlt',
    neutralQuaternaryAlt2: '--ms-themeColorPaletteNeutralQuaternaryAlt2',
    neutralLight: '--ms-themeColorPaletteNeutralLight',
    neutralLightAlt: '--ms-themeColorPaletteNeutralLightAlt',
    neutralLighter: '--ms-themeColorPaletteNeutralLighter',
    neutralLighterAlt: '--ms-themeColorPaletteNeutralLighterAlt',
    white: '--ms-themeColorPaletteWhite',
    yellowDark: '--ms-themeColorPaletteAccentYellowDark',
    yellow: '--ms-themeColorPaletteAccentYellow',
    yellowLight: '--ms-themeColorPaletteAccentYellowLight',
    orange: '--ms-themeColorPaletteAccentOrange',
    orangeLight: '--ms-themeColorPaletteAccentOrangeLight',
    orangeLighter: '--ms-themeColorPaletteAccentOrangeLighter',
    redDark: '--ms-themeColorPaletteAccentRedDark',
    red: '--ms-themeColorPaletteAccentRed',
    magentaDark: '--ms-themeColorPaletteAccentMagentaDark',
    magenta: '--ms-themeColorPaletteAccentMagenta',
    magentaLight: '--ms-themeColorPaletteAccentMagentaLight',
    purpleDark: '--ms-themeColorPaletteAccentPurpleDark',
    purple: '--ms-themeColorPaletteAccentPurple',
    purpleLight: '--ms-themeColorPaletteAccentPurpleLight',
    blueDark: '--ms-themeColorPaletteAccentBlueDark',
    blueMid: '--ms-themeColorPaletteAccentBlueMid',
    blue: '--ms-themeColorPaletteAccentBlue',
    blueAlt: '--ms-themeColorPaletteAccentBlueAlt',
    blueLight: '--ms-themeColorPaletteAccentBlueLight',
    tealDark: '--ms-themeColorPaletteAccentTealDark',
    teal: '--ms-themeColorPaletteAccentTeal',
    tealLight: '--ms-themeColorPaletteAccentTealLight',
    greenDark: '--ms-themeColorPaletteAccentGreenDark',
    green: '--ms-themeColorPaletteAccentGreen',
    greenLight: '--ms-themeColorPaletteAccentGreenLight',
    // Tokens specific to Fluid, we should aim to have as least as possible tokens in here and
    // try to use tokens available elsewhere.
    SuggestionAcceptedBackground: '--ms-themeColorPaletteProofingSuggestionAcceptedBackground',
    SpellingSuggestionHoverHighlight: '--ms-themeColorPaletteProofingSpellingSuggestionHoverHighlight',
    SpellingHoverTextColor: '--ms-themeColorPaletteProofingSpellingHoverTextColor',
    GrammarSuggestionHoverHighlight: '--ms-themeColorPaletteProofingGrammarSuggestionHoverHighlight',
    GrammarHoverTextColor: '--ms-themeColorPaletteProofingGrammarHoverTextColor',
    HeadingDetectedHoverHighlight: '--ms-themeColorPaletteAnnotationsHeadingDetectedHoverHighlight',
    HeadingDetectedHoverTextColor: '--ms-themeColorPaletteAnnotationsHeadingDetectedHoverTextColor',
    TaskRecognitionUnderline: '--ms-themeColorPaletteAnnotationsTaskRecognitionUnderline',
    TaskRecognitionHoverHighlight: '--ms-themeColorPaletteAnnotationsTaskRecognitionHoverHighlight',
    TaskRecognitionHoverTextColor: '--ms-themeColorPaletteAnnotationsTaskRecognitionHoverTextColor',
    EntityRecognitionUnderline: '--ms-themeColorPaletteAnnotationsEntityRecognitionUnderline',
    EntityRecognitionHoverHighlight: '--ms-themeColorPaletteAnnotationsEntityRecognitionHoverHighlight',
    EntityRecognitionHoverTextColor: '--ms-themeColorPaletteAnnotationsEntityRecognitionHoverTextColor',
    Scrollbar: '--ms-themeColorScrollbar',
    ScrollbarPressed: '--ms-themeColorScrollbarPressed',
    HeadingText: '--ms-themeColorHeadingText'
};
